
const highlighter = {
    /**
     * Used to higlight any string part with matching term.
     * Returns string with bolded matching string wrapped with HTML <b> tag.
     * @param string
     * @param term
     * @returns HTML string
     */
    highlightText(string, term) {
        const pattern = `(.*)(${term.trim()})(.*)`;
        const regex   = new RegExp(pattern, 'ig');
        return string.replace(regex, '$1<b>$2</b>$3');
    }
}

export default highlighter;